import Vue from 'vue'

// // 选择区划
// import selectDistrict from '@/components/selectDistrict'
// 数据字典下拉框（单/多选）
import selectFromDictionary from '@/components/selectFromDictionary'
// // 数据字典checkbox
// import checkboxFromDictionary from '@/components/checkboxFromDictionary'
// // 地图选择
// import selectAddress from '@/components/selectAddress'
// // 导入模板
// import importData from '@/components/importData'
// // 表单查询
// import searchForm from '@/components/searchForm'
// // 选择省市县
// import selectCity from '@/components/selectCity/index'
// // 查看隐私信息
// import viewHideValue from '@/components/viewHideValue'

// import selectResDistrict from '@/components/selectResDistrict'

// Vue.component('select-district', selectDistrict)
Vue.component('select-from-dictionary', selectFromDictionary)
// Vue.component('checkbox-from-dictionary', checkboxFromDictionary)
// Vue.component('select-address', selectAddress)
// Vue.component('import-data', importData)

// Vue.component('search-form', searchForm)
// Vue.component('select-city', selectCity)
// Vue.component('view-hide-value', viewHideValue)
// Vue.component('select-res-district', selectResDistrict)
